
import state from './../../zviz2/zviz/state';
import Group from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import Link from './../../zviz2/zviz/components/link';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {styleWords, styleText} from './../../styles';
import config from './../../config';
//import {LifeCycle} from './../zviz2/zviz/cycle';

import ListFilter from './list';



let Blueprint = extend({
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'otherFiltersShown') ),
    ],
    children: [ 
        extend({
            properties: {
                style: {
                    backgroundColor: '#230050',
                    padding: '0px 8px',
                    position: 'relative',
                    marginTop: '30px'
                }
            },
            children: [
                extend({
                    properties: {
                        style: extend({
                            color: 'white',
                            lineHeight: '30px'
                        }, styleWords),
                        content: 'Other filters'
                    },
                }, TextBox),

                extend({
                    properties: {
                        style: extend({
                            position: 'absolute',
                            right: '7px',
                            top: '0px',
                            color: 'white',
                            fontSize: '9pt',
                            fontStyle: 'italic',
                            display: 'block',
                            height: '30px',
                            lineHeight: '30px',
                            paddingRight: '30px',
                            background: (ctrl) => ( state.get('otherFiltersShown')?  
                                    'transparent url(\'' + config.imgPath + 'up-arrow-large.png\') right center no-repeat':
                                    'transparent url(\'' + config.imgPath + 'down-arrow-large.png\') right center no-repeat' )
                        }, styleWords),
                        content: (ctrl) => (state.get('otherFiltersShown')? 'hide': 'show' )  
                    },
                    events: {
                        click: (event, ctrl) => { 
                            state.get('otherFiltersShown')?
                                    state.set('otherFiltersShown', null): state.set('otherFiltersShown', true);
                        }
                    }
                }, Link)
            ]
        }, Group),

        (ctrl) => (state.get('otherFiltersShown')? cloneObject(BlueprintFilters): [] )
     ]
}, Group);

let BlueprintFilters = extend({
    properties: {
        style: {
            border: '1px solid #d3d3d3',
            padding: '10px 15px'
        }
    },
    children: [
        (ctrl) => { if(state.get('view') == 'regional'){
                return [];
            }else{
                return extend({
                    properties: {
                        data: {name: 'theme'},
                        style: {
                            width: (ctrl) => ((state.get('renderSize') == 'medium')? '46%': 'auto'),
                            padding: (ctrl) => ((state.get('renderSize') == 'medium')? '0% 2%': '0px'),
                            display: (ctrl) => ((state.get('renderSize') == 'medium')? 'inline-block': 'block'),
                            verticalAlign: 'top'
                        }
                    }
                }, ListFilter);
            }
        },
        extend({
            properties: {
                data: {name: 'country'},
                style: {
                    width: (ctrl) => ((state.get('renderSize') == 'medium')? '46%': 'auto'),
                    padding: (ctrl) => ((state.get('renderSize') == 'medium')? '0% 2%': '0px'),
                    display: (ctrl) => ((state.get('renderSize') == 'medium')? 'inline-block': 'block'),
                    verticalAlign: 'top'
                }
            }
        }, ListFilter),

        extend({
            properties: {
                data: {name: 'eval_type'},
                style: {
                    width: (ctrl) => ((state.get('renderSize') == 'medium')? '46%': 'auto'),
                    padding: (ctrl) => ((state.get('renderSize') == 'medium')? '0% 2%': '0px'),
                    display: (ctrl) => ((state.get('renderSize') == 'medium')? 'inline-block': 'block'),
                    verticalAlign: 'top'
                }
            }
        }, ListFilter),

        extend({
            properties: {
                data: {name: 'eval_nature'},
                style: {
                    width: (ctrl) => ((state.get('renderSize') == 'medium')? '46%': 'auto'),
                    padding: (ctrl) => ((state.get('renderSize') == 'medium')? '0% 2%': '0px'),
                    display: (ctrl) => ((state.get('renderSize') == 'medium')? 'inline-block': 'block'),
                    verticalAlign: 'top'
                }
            }
        }, ListFilter),

        extend({
            properties: {
                data: {name: 'eval_timing'},
                style: {
                    width: (ctrl) => ((state.get('renderSize') == 'medium')? '46%': 'auto'),
                    padding: (ctrl) => ((state.get('renderSize') == 'medium')? '0% 2%': '0px'),
                    display: (ctrl) => ((state.get('renderSize') == 'medium')? 'inline-block': 'block'),
                    verticalAlign: 'top'
                }
            }
        }, ListFilter),

        extend({
            properties: {
                data: {name: 'funding_source'},
                style: {
                    width: (ctrl) => ((state.get('renderSize') == 'medium')? '46%': 'auto'),
                    padding: (ctrl) => ((state.get('renderSize') == 'medium')? '0% 2%': '0px'),
                    display: (ctrl) => ((state.get('renderSize') == 'medium')? 'inline-block': 'block'),
                    verticalAlign: 'top'
                }
            }
        }, ListFilter)
    ]
}, Group);

export default Blueprint;
export {Controller, Blueprint};
